import { RouterProvider } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import { usePWAUpdate } from '@/hooks/usePWAUpdate';
import { router } from '@/router';
import { BillingHostProvider } from '@/components/layout/BillingHostProvider';

/**
 * Logged-out screens (login, sign-up, password reset) hold no unsaved work,
 * so a new app version is applied there without asking; signed-in users get
 * the prompt in AppLayout instead.
 */
function LoggedOutAutoUpdate() {
  const { isAuthenticated, isLoading } = useAuth();
  usePWAUpdate({ autoApply: !isLoading && !isAuthenticated });
  return null;
}

function App() {
  return (
    <AuthProvider>
      <LoggedOutAutoUpdate />
      <BillingHostProvider>
        <RouterProvider router={router} />
      </BillingHostProvider>
    </AuthProvider>
  );
}

export default App;
